import "./EmailToContinue.scss";
import React, { Component } from "react";
import { observer } from "mobx-react";
import { Button, TextInput } from "../lib";
import emailRegex from "email-regex";
import { Redirect } from "react-router-dom";
import { assessStore, resultStore } from "../stores";
import authStore from "../auth/auth-store";

class EmailToContinue extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = { email: "", firstName: "", lastName: "" };
  }

  handleChange(field) {
    return (value) => {
      this.setState({ [field]: value });
    };
  }

  handleSubmit(email) {
    if (window.fbq) {
      window.fbq("track", "Contact");
    }

    assessStore.submit(
      this.state.email || email,
      this.state.firstName,
      this.state.lastName
    );
  }

  get valid() {
    return (
      this.state.firstName &&
      this.state.lastName &&
      emailRegex({ exact: true }).test(this.state.email)
    );
  }

  render() {
    if (resultStore.localResponse) {
      return <Redirect to="/results" />;
    }

    if (authStore.auth && authStore.auth.email) {
      return (
        <div>
          <h1 style={{ marginBottom: 10 }}>Ready to submit!</h1>
          <Button
            styleType="primary"
            onClick={() => this.handleSubmit(authStore.auth.email)}
          >
            Submit
          </Button>
        </div>
      );
    }

    return (
      <div className="EmailToContinue">
        <h1 style={{ marginBottom: 10 }}>You're almost done!</h1>
        <p style={{ marginBottom: 10 }}>
          Just enter your name and email to view your assessment results!
        </p>
        <div style={{ display: "flex", maxWidth: 400, paddingBottom: 10 }}>
          <TextInput
            type="text"
            placeholder="First Name"
            value={this.state.firstName}
            onChange={this.handleChange("firstName")}
          />
          <div style={{ width: 10 }}></div>
          <TextInput
            type="text"
            placeholder="Last Name"
            value={this.state.lastName}
            onChange={this.handleChange("lastName")}
          />
        </div>
        <TextInput
          style={{ marginBottom: 10 }}
          type="email"
          placeholder="Enter your email"
          onChange={this.handleChange("email")}
          onEnter={this.handleSubmit}
          value={this.state.email}
          autoFocus
        />
        <Button onClick={this.handleSubmit} disabled={!this.valid}>
          Submit
        </Button>
      </div>
    );
  }
}

EmailToContinue.displayName = "EmailToContinue";

export default observer(EmailToContinue);



// WEBPACK FOOTER //
// ./src/assess/EmailToContinue.js